import { render, staticRenderFns } from "./TenantsViewer.vue?vue&type=template&id=f51727f0&scoped=true"
import script from "./TenantsViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./TenantsViewer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TenantsViewer.vue?vue&type=style&index=0&id=f51727f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51727f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f51727f0')) {
      api.createRecord('f51727f0', component.options)
    } else {
      api.reload('f51727f0', component.options)
    }
    module.hot.accept("./TenantsViewer.vue?vue&type=template&id=f51727f0&scoped=true", function () {
      api.rerender('f51727f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/apps/tenants/TenantsViewer.vue"
export default component.exports